<template>
  <div class="app-down-tour">
    <a role="button" href="https://itunes.apple.com/cn/app/%E8%BA%AB%E6%9D%90%E8%A7%89%E9%86%92/id1329616360">立刻下载</a>
  </div>
</template>

<script>
export default {
    name: 'AppTour',
};
</script>

<style lang="scss">
.app-down-tour {
    display: block;
    margin: 8vw auto;
    width: 71.466667vw;
    height: 94.4vw;
    background-image: url('../../assets/images/app-down-tour.png');
    background-size: cover;
    position: relative;

    > a {
        position: absolute;
        top: 47.866667vw;
        left: 28.2666667vw;
        width: 42.666667vw;
        height: 9.333333vw;
        border-radius: 10px;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(182, 182, 182, 0.7));
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
        border: solid 2px #9a9a9a;
        text-align: center;
        font-size: 4.266667vw;
        color: #353535;
        line-height: 9.333333vw;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/calendar/AppTour.vue